import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";
import ChevronUpIcon from "@dcl/icons/esm/ui/chevron-up";

var FilterSectionOverflow = function FilterSectionOverflow(_ref) {
  var collapseText = _ref.collapseText,
      expandText = _ref.expandText,
      children = _ref.children;
  var getClassName = getClassNameFactory("SearchFiltersFilterSectionOverflow");

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setState = _useState2[1];

  var handleToggle = function handleToggle() {
    return setState(!isExpanded);
  };

  var titleText = isExpanded ? collapseText : expandText;
  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      states: isExpanded ? "expanded" : ""
    }),
    "data-collapse-text": collapseText,
    "data-expand-text": expandText,
    "data-rehydratable": getRehydratableName(FilterSectionOverflow.displayName)
  }, /*#__PURE__*/React.createElement("ul", {
    className: getClassName({
      descendantName: "items"
    })
  }, children), /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "toggleButton"
    }),
    onClick: handleToggle
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "toggleButtonIcon"
    })
  }, isExpanded ? /*#__PURE__*/React.createElement(ChevronUpIcon, null) : /*#__PURE__*/React.createElement(ChevronDownIcon, null)), /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "toggleButtonText"
    })
  }, titleText)));
};

FilterSectionOverflow.displayName = "SearchFilters.FilterSectionOverflow";
FilterSectionOverflow.defaultProps = {
  collapseText: "See less",
  expandText: "See more"
};
export default FilterSectionOverflow;